<template>
    <div>
        <h5 class="info-text">
            Let's start with the basic information.
        </h5>
        <div class="row justify-content-center mt-5">
            <div class="col-sm-5">
                <base-input
                    name="first_name"
                    required
                    label="First Name"
                    placeholder="First Name"
                    v-model="model.first_name"
                    v-validate="modelValidations.first_name"
                    :error="getError('first_name')"
                >
                </base-input>
            </div>
            <div class="col-sm-5">
                <base-input
                    name="last_name"
                    required
                    type="text"
                    label="Last name"
                    placeholder="Last Name"
                    v-model="model.last_name"
                    v-validate="modelValidations.last_name"
                    :error="getError('last_name')"
                >
                </base-input>
            </div>
            <div class="col-sm-5">
                <base-input
                    type="text"
                    required
                    v-validate="'required'"
                    label="School name"
                    placeholder="Company"
                    v-model="model.company"
                    name="company"
                    data-vv-as="Company"
                    :error="getError('company')"
                >
                </base-input>
            </div>
            <div class="col-sm-5">
                <base-input
                    type="text"
                    label="School URN"
                    placeholder="BE ..."
                    v-model="model.company_number"
                    name="company_number"
                    data-vv-as="Company Number"
                    :error="getError('company_number')"
                >
                </base-input>
            </div>
            <div class="col-sm-5">
                <base-input
                    name="email"
                    required
                    label="Email"
                    placeholder="Email"
                    v-model="model.email"
                    v-validate="modelValidations.email"
                    :error="getError('email')"
                >
                </base-input>
            </div>
            <div class="col-sm-5">
                <base-input
                    name="phone"
                    required
                    label="Phone"
                    placeholder="Phone"
                    v-model="model.phone"
                    v-validate="modelValidations.phone"
                    :error="getError('phone')"
                >
                </base-input>
            </div>
            <div class="col-sm-4">
                <base-input
                    name="address"
                    label="Address"
                    placeholder="Address"
                    required
                    v-model="model.address"
                    v-validate="modelValidations.address"
                    :error="getError('address')"
                >
                </base-input>

            </div>
            <div class="col-sm-3">
                <base-input
                    type="text"
                    label="City"
                    placeholder="City"
                    v-model="model.city"
                    name="city"
                    required
                    v-validate="'required'"
                    data-vv-as="City"
                    :error="getError('city')"
                >
                </base-input>

            </div>
            <div class="col-sm-3">
                <base-input
                    label="Postal Code"
                    placeholder="Postal Code"
                    v-model="model.postal_code"
                    name="postal_code"
                    v-validate="'required'"
                    required
                    data-vv-as="Postal Code"
                    :error="getError('postal_code')"
                >
                </base-input>
            </div>
            <div class="col-sm-10">
                <base-input
                    name="country"
                    placeholder="Country"
                    label="Country"
                    v-validate="modelValidations.country"
                    :error="getError('country')"
                >
                    <select v-model="model.country" class="form-control" id="exampleFormControlSelect1">
                        <option value="BEL">Belgium</option>
                        <option value="GBR">United Kingdom</option>
                        <option value="USA">United States</option>
                    </select>
                </base-input>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                model: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    company: '',
                    company_number: '',
                    address: '',
                    postal_code: '',
                    city: '',
                    country: 'GBR'
                },
                modelValidations: {
                    first_name: {
                        required: true,
                        min: 2
                    },
                    last_name: {
                        required: true,
                        min: 2
                    },
                    email: {
                        required: true,
                        email: true
                    }, address: {
                        required: true,
                    },
                    phone: {
                        required: true,
                        numeric: true
                    }
                }
            };
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
            validate() {
                return this.$validator.validateAll().then(res => {
                    this.$emit('on-validated', res, this.model);
                    return res;
                });
            }
        }
    };
</script>
<style></style>
